import type {
  LegacyApiAction,
  LegacyApiResponse,
  LegacyDispatch,
} from '../api-middleware.types';
export const nextAction =
  (next: LegacyDispatch) =>
  (action: LegacyApiAction) =>
  (response: LegacyApiResponse) => {
    const { data, status } = response;

    // Dispatch next action only for success or no content statuses
    if (status === 200 || status === 204) {
      const { meta, ...forwardedAction } = action;
      void meta;
      next({ ...forwardedAction, data });
    }
  };
